import { render, staticRenderFns } from "./TipiScarico.vue?vue&type=template&id=0c4bdd10&"
import script from "./TipiScarico.vue?vue&type=script&lang=js&"
export * from "./TipiScarico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports